// @flow
import React from 'react'
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'waiting-time-ends',
  icon: [
    45,
    26,
    null,
    null,
    null,
    <g fill="currentColor" fillRule="evenodd" key="waiting-time-ends">
      <path d="M23.722 20.675c-1.444 0-2.614 1.191-2.614 2.662 0 1.47 1.17 2.663 2.614 2.663s2.614-1.192 2.614-2.663c0-1.47-1.17-2.662-2.614-2.662zm-18.816 0c-1.444 0-2.614 1.191-2.614 2.662 0 1.47 1.17 2.663 2.614 2.663s2.614-1.192 2.614-2.663c0-1.47-1.17-2.662-2.614-2.662zm-4.74-.345c-.288.537-.432 3.2 1.583 3.47h.037a3.412 3.412 0 0 1-.024-.392c0-1.787 1.423-3.235 3.177-3.235s3.176 1.448 3.176 3.235c0 .206-.02.407-.056.602l12.646.425a3.285 3.285 0 0 1-.165-1.027c0-1.787 1.423-3.235 3.177-3.235s3.176 1.448 3.176 3.235c0 .39-.068.765-.193 1.112l1.43.012S30 24.41 30 23.212v-2.589s-.288-.562-.288-.904c0-.342-.48-.854-.647-1.001 0 0-.216-1.368-4.437-2.1 0 0-1.726-.22-2.182-.538-.456-.318-4.365-4.08-8.994-4.08-4.628 0-8.082.83-8.082.83s-1.175.318-1.463.318c-.287 0-.503.342-.36.831 0 0-1.774 1.27-1.966 2.003 0 0-.767-.05-.911.782-.144.83-.216 3.03-.504 3.566z" />
      <g fill="#C02828">
        <path d="M32 3c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5m0 12c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7" />
        <path d="M35 9h-4V4h2v3h2z" />
      </g>
      <text
        fill="#C02828"
        fontFamily="Roboto-Black, Roboto"
        fontSize="20"
        fontWeight="700"
        transform="translate(0 -4)"
      >
        <tspan x="40.241" y="19">
          !
        </tspan>
      </text>
    </g>,
  ],
})
